import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export default (t: TFunction): any =>
  yup.object({
    description: yup.string().required(t('schema-sitef-form-descrption-required')),
    merchantId: yup.string().required(t('schema-sitef-form-merchantId-required')),
    merchantKey: yup.string().required(t('schema-sitef-form-merchantKey-required')),
  });
